module.exports = __webpack_public_path__ + "img/pin1.d74f27bd.svg";